const DEFAULT_BASE = "https://www.jamilglobal.com";

/**
 * Canonical site origin for SEO, JSON-LD, and Open Graph (no trailing slash).
 * Must match the host users and bots land on (production redirects apex → www).
 * Accepts REACT_APP values like "www.jamilglobal.com", "https://www.jamilglobal.com/", etc.
 */
export function getPublicBaseUrl(raw = process.env.REACT_APP_BASE_URL) {
  if (!raw || !String(raw).trim()) return DEFAULT_BASE;

  let s = String(raw).trim();
  if (!/^https?:\/\//i.test(s)) {
    s = `https://${s.replace(/^\/+/, "")}`;
  }

  try {
    const u = new URL(s);
    if (!u.hostname) return DEFAULT_BASE;
    const port =
      u.port && !["80", "443"].includes(u.port) ? `:${u.port}` : "";
    return `${u.protocol}//${u.hostname}${port}`;
  } catch {
    return DEFAULT_BASE;
  }
}
